import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class GatePassApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.GATE_PASS);
  }

  getReceivedList(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}received-list/?${queryString}`
      : `${this.getResourceUrl()}received-list/`;

    return this.httpClient.get(url);
  }

  list(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}list/?${queryString}`
      : `${this.getResourceUrl()}list/`;

    return this.httpClient.get(url);
  }

  addItem(gatePassId, item) {
    return this.httpClient.post(
      `${this.getResourceUrl()}${gatePassId}/add-item/`,
      item,
    );
  }

  submit(gatePassId) {
    return this.httpClient.put(
      `${this.getResourceUrl()}${gatePassId}/submit/`,
      { status: 'submitted' },
    );
  }

  deleteItem(gatePassId, itemId) {
    return this.httpClient.put(
      `${this.getResourceUrl()}${gatePassId}/delete-items/`,
      { ids: [itemId] },
    );
  }

  getItems(gatePassId) {
    return this.httpClient.get(`${this.getResourceUrl()}${gatePassId}/items/`);
  }

  exportItems(gatePassId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${gatePassId}/items/export/`,
    );
  }
}

export default new GatePassApi();
